var React = require('react');

function WorkInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"work_24px"},React.createElement("path",{"id":"icon/action/work_24px","fillRule":"evenodd","clipRule":"evenodd","d":"M33.3334 13.5417H41.6668C43.9793 13.5417 45.8334 15.3958 45.8334 17.7083V40.625C45.8334 42.9375 43.9793 44.7917 41.6668 44.7917H8.33342C6.02091 44.7917 4.16675 42.9375 4.16675 40.625L4.18758 17.7083C4.18758 15.3958 6.02091 13.5417 8.33342 13.5417H16.6667V9.37499C16.6667 7.06249 18.5209 5.20833 20.8334 5.20833H29.1667C31.4792 5.20833 33.3334 7.06249 33.3334 9.37499V13.5417ZM20.8334 13.5417H29.1667V9.375H20.8334V13.5417Z","fill":"white"})));
}

WorkInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = WorkInline;

WorkInline.default = WorkInline;
